import React, { useEffect, useState } from 'react';
import { Link, Route, HashRouter as Router, Routes, useParams, useNavigate } from 'react-router-dom';
import './Menu.css';
import MenuPage from './MenuPage'; // Import the MenuPage component
import './header.css';
import './SearchBar'; // Assuming this is the new CSS file or updated one

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>X</button>
        {children}
      </div>
    </div>
  );
};

const RestaurantCard = ({ image, address, code, vegnonveg, rating, ratingno, room, onCardClick }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    onCardClick(address, code, navigate);
  };

  return (
    <div className="restaurant-card" onClick={handleCardClick}>
      <img className="restaurant-image" src={image} alt="Restaurant" />
      <div className="restaurant-details">
        <span className="restaurant-address">
          {address}
          <span className={`restaurant-place ${vegnonveg === 'veg' ? 'veg' : 'non-veg'}`}>
            ▣
          </span>
        </span>
        <div className="container">
          <span className="restaurant-rating">
            {rating}
            <span className="ratingno">({ratingno})</span>
          </span>
        </div>
      </div>
    </div>
  );
};

const App = () => {
  const [restaurants, setRestaurants] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const response = await fetch('https://opensheet.elk.sh/1aRTSsszzIKfAd5Qy5ZPrBZqBbgabqEl3LBtcW9SK3zM/Sheet1!A1:Z99999');
        if (!response.ok) {
          throw new Error('Failed to fetch data from the API');
        }
        const data = await response.json();
        setRestaurants(data);
      } catch (error) {
        console.error(error);
        // Handle error state if needed
      }
    };

    fetchRestaurants();
  }, []);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const performSearch = () => {
    const filteredRestaurants = restaurants.filter(restaurant =>
      restaurant.address.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(filteredRestaurants);
  };

  const displayRestaurants = searchResults !== null ? searchResults : restaurants;

  const uniqueAddresses = new Set();
  const filteredRestaurants = displayRestaurants.filter((restaurant) => {
    if (uniqueAddresses.has(restaurant.address)) {
      return false;
    }
    uniqueAddresses.add(restaurant.address);
    return true;
  });

  const handleCardClick = (address, code, navigate) => {
    const sameAddressRestaurants = restaurants.filter(r => r.address === address);
    if (sameAddressRestaurants.length > 1) {
      setModalContent({ restaurants: sameAddressRestaurants, navigate });
      setModalOpen(true);
    } else {
      navigate(`/${code}`);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent(null);
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="restaurant-container">
              <div className="search-div">
                <input
                  type="text"
                  placeholder="Search for a restaurant"
                  value={searchTerm}
                  onChange={handleSearch}
                  className="search-input"
                />
                <button onClick={performSearch} className="search-button">Search</button>
              </div>
              <div className="restaurant-grid">
                {filteredRestaurants.map((restaurant, index) => (
                  <RestaurantCard
                    key={index}
                    image={restaurant.image}
                    address={restaurant.address}
                    vegnonveg={restaurant.vegnonveg}
                    rating={restaurant.rating}
                    ratingno={restaurant.ratingno}
                    code={restaurant.code}
                    room={restaurant.room}
                    onCardClick={handleCardClick}
                  />
                ))}
              </div>
              <Modal className="Room_info" isOpen={modalOpen} onClose={closeModal}>
                <h2>Room Information</h2>
                {modalContent && modalContent.restaurants.map((r, index) => (
                  <div key={index} className="room_information">
                    <button className='root' onClick={() => modalContent.navigate(`/${r.code}`)}>
                      {r.room}
                    </button>
                  </div>
                ))}
              </Modal>
            </div>
          }
        />
        <Route path="/:code" element={<RestaurantMenu restaurants={restaurants} />} />
      </Routes>
    </Router>
  );
};

const RestaurantMenu = ({ restaurants }) => {
  const { code } = useParams();
  const restaurant = restaurants.find((r) => r.code === code);

  if (!restaurant) {
    return <div></div>;
  }

  return (
    <div>
      <MenuPage menu1={restaurant.menu1} />
    </div>
  );
};

export default App;
